<template>
  <v-app>
    <v-container fluid class="mt-16 pt-16">
      <v-row>
        <v-col offset-md="4" class="text-h5">Pick the customer/distillery to view</v-col>
      </v-row>
      <v-row>
        <v-col md="4" offset-md="4">
          <v-list>
            <v-list-item v-for="company of $store.state.companies" :key="company.customerId"
                        @click="$store.commit('setCustomerId', company.customerId);$router.replace({path:'/'})">
              {{company.customerName}} @ {{company.companyName}}
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>

export default {
  name: 'PickCustomer'
}
</script>